import { Button, Card, LazyLoader, Logo } from '@bp/ui-components';
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import styles from './RequireAuth.module.css';

type RequireAuthProps = {
  children?: React.ReactNode;
};

export const RequireAuth = memo(({ children }: RequireAuthProps) => {
  const { t } = useTranslation();
  const auth = useAuth();

  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  const login = async () => {
    await auth.signinRedirect();
  };

  React.useEffect(() => {
    if (!hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasTriedSignin) {
      void auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  if (auth.isLoading) {
    return <LazyLoader embedded forceHeight='100vh' forceWidth='100vw' />;
  }

  if (auth.error) {
    let errorMessage = auth.error.message;
    if (auth.error.message.includes('access denied')) {
      errorMessage = 'Leider hat ihr aktueller Benutzer keinen Zugriff auf diese Software.';
    }
    return (
      <div className={styles.wrapper} data-cy='layoutWrapper'>
        <main className={styles.container}>
          <Card>
            <div className={styles.logo}>
              <Logo type={'planung'} collapsed={false} />
            </div>
            <div className={styles.vspace}>{t('auth.app-about')}</div>

            <div>{errorMessage}</div>
            <div className={styles.vspace}>
              <Button hierarchy='primary' onClick={() => login()} fullWidth={true}>
                {t('auth.login')}
              </Button>
            </div>
            <div className={styles.vspace}>
              <Button hierarchy='primary' onClick={() => auth.signoutRedirect({})} fullWidth={true}>
                {t('auth.logout')}
              </Button>
            </div>
          </Card>
        </main>
        <footer>Impressum | Datenschutz | Nutzungsbedingungen | Partner</footer>
      </div>
    );
  }

  if (auth.isAuthenticated) {
    return <>{children}</>;
  }
});
RequireAuth.displayName = 'RequireAuth';
